import { putApi } from '../../../utils/api'

export function updateSearchResultsEmailsTableConfig(data) {
  return putApi({
    data,
    endpoint: 'idwell-api/api/v3/table/tables/email-messages-search/config/',
  })
}
